import type { ToastContentProps } from './types'

import { Toast as BaseToast } from '@base-ui/react/toast'

import { surfaceVariants } from '#components/surface/styles'
import { cn } from '#lib/cn'

/**
 * Toast content container.
 *
 * Content behind the frontmost toast fades out in collapsed mode.
 */
export function ToastContent({ className, ...props }: ToastContentProps) {
  return (
    <BaseToast.Content
      className={cn(
        'h-full overflow-hidden',
        'flex gap-2.5 p-3',
        // Chrome (background, border, radius, shadow) via Surface primitive
        surfaceVariants(),
        'text-text-primary',
        className,
      )}
      {...props}
    />
  )
}
ToastContent.displayName = 'Toast.Content'
